import * as React from "react";
const Session = (props) => (
  <svg
    width={16}
    height={13}
    viewBox="0 0 16 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2584 9.01614C13.941 9.01614 13.6777 8.75292 13.6777 8.4355C13.6777 8.11808 13.941 7.85485 14.2584 7.85485C14.7152 7.85485 14.8158 7.78518 14.8235 7.78518C14.839 7.73873 14.839 7.46776 14.839 7.27421V5.72582C14.839 5.53227 14.839 5.26905 14.8081 5.19937C14.8003 5.20711 14.6842 5.14518 14.2584 5.14518C13.941 5.14518 13.6777 4.88195 13.6777 4.56453C13.6777 4.24711 13.941 3.98389 14.2584 3.98389C15.8687 3.98389 16.0003 4.77356 16.0003 5.72582V7.27421C16.0003 8.22647 15.8687 9.01614 14.2584 9.01614Z"
      fill="#4B5155"
    />
    <path
      d="M4.32633 8.62904C4.27988 8.62904 4.23343 8.62129 4.18698 8.61355C3.8773 8.53613 3.68375 8.21871 3.76117 7.90904C3.99343 6.98775 3.99343 6.01226 3.76117 5.09097C3.68375 4.78129 3.86956 4.46388 4.18698 4.38646C4.49666 4.30904 4.80633 4.50258 4.88375 4.81226C5.16246 5.91936 5.16246 7.08839 4.88375 8.18775C4.82182 8.45097 4.58182 8.62904 4.32633 8.62904Z"
      fill="#4B5155"
    />
    <path
      d="M7.0363 8.629C6.98984 8.629 6.94339 8.62126 6.89694 8.61351C6.58726 8.53609 6.39372 8.21868 6.47113 7.909C6.70339 6.98771 6.70339 6.01222 6.47113 5.09093C6.39372 4.78126 6.57952 4.46384 6.89694 4.38642C7.20662 4.309 7.52404 4.4948 7.60146 4.81222C7.88017 5.91932 7.88017 7.08835 7.60146 8.18771C7.53178 8.45093 7.29178 8.629 7.0363 8.629Z"
      fill="#4B5155"
    />
    <path
      d="M8.45175 12.5H4.80659C1.3924 12.5 0.35498 11.4626 0.35498 8.04839V4.95161C0.35498 1.53742 1.3924 0.5 4.80659 0.5H8.45175C11.8659 0.5 12.9034 1.53742 12.9034 4.95161V8.04839C12.9034 11.4626 11.8659 12.5 8.45175 12.5ZM4.80659 1.66129C2.04272 1.66129 1.51627 2.18774 1.51627 4.95161V8.04839C1.51627 10.8123 2.04272 11.3387 4.80659 11.3387H8.45175C11.2156 11.3387 11.7421 10.8123 11.7421 8.04839V4.95161C11.7421 2.18774 11.2156 1.66129 8.45175 1.66129H4.80659Z"
      fill="#4B5155"
    />
  </svg>
);
export default Session;
